import { takeLatest } from 'redux-saga/effects';
import noScroll from 'no-scroll';

/**
 * This scroll lock is mainly for IOS Safari where background is scrollable
 * even if the overflow hidden strategy is used on background content, causing
 * broken UI is some cases.
 *
 * The elastic band functionality will make the content behind be shown
 * in the bottom portion of the phone when the menu slides away.
 */

import {
  OPEN_MOBILE_MENU,
  CLOSE_MOBILE_MENU,
} from '../../areas/navigation/actions/mobile-menu';

import { FEEDBACK_OPEN, FEEDBACK_CLOSE } from '../../areas/feedback/actions';

import {
  OPEN_REVIEW_DIALOG,
  CLOSE_REVIEW_DIALOG,
} from '../../areas/reviews/actions';

import { CAMPAIGN_QUERY } from '../../areas/campaign/actions';

function* scrollLockOn() {
  yield noScroll.on();
}

function* scrollLockOff() {
  yield noScroll.off();
}

export default function* scrollLockSaga() {
  yield takeLatest(OPEN_MOBILE_MENU, scrollLockOn);
  yield takeLatest(CLOSE_MOBILE_MENU, scrollLockOff);

  yield takeLatest(FEEDBACK_OPEN, scrollLockOn);
  yield takeLatest(FEEDBACK_CLOSE, scrollLockOff);

  yield takeLatest(OPEN_REVIEW_DIALOG, scrollLockOn);
  yield takeLatest(CLOSE_REVIEW_DIALOG, scrollLockOff);

  // We release the lock on new route load (campaign query for campaign page)
  // events to handle back actions and other unexpected page changes where the
  // user might not be able to go through the regular close path of
  // modals | menus | dialogs.

  // This might result in the scroll lock being released even if the
  // menu is still open when doing stuff like hitting the back button
  // (because of SPA). But its better than the other way around: the
  // main content being non-scrollable.
  yield takeLatest('ROUTE_LOADED', scrollLockOff);
  yield takeLatest(CAMPAIGN_QUERY, scrollLockOff);
}
